import { AlertColor } from '@mui/material/Alert';

let snackbarRef: ((message: string, severity?: AlertColor, ttl?: number) => void) | null = null;

export const snackbarService = {
  register(fn: (message: string, severity?: AlertColor, ttl?: number) => void) {
    snackbarRef = fn;
  },

  showSnackbar(
    message: string,
    severity: AlertColor = 'info',
    ttl: number = 3000
  ) {
    if (!snackbarRef) {
      console.warn('Snackbar service not registered');
      return;
    }

    snackbarRef(message, severity, ttl);
  }
};